export interface BasePcList {
  id: string; // 标识 id
  name: string; // 路由 name
  path: string; // 路由 path
  link?: string; // 下载链接
  filename?: string; // 自定义文件名称
  isBaiduApiToken?: string; // 需要百度上报apitoken拼接
}

export const basePcList: BasePcList[] = [
  {
    id: "10001",
    name: "swbd2",
    path: "/swbd2",
    filename: "996boxV360SetupSigned@6102.exe",
    link: "//static.dhsf.996box.com/box/channel_app/996boxV360SetupSigned@6102.exe",
    isBaiduApiToken:
      "2du5kihwl29kY7qU8jE9wdmM5jrpz2YC@njw0ZjB6D9ZSbFN4px1YvYwCOti3y4lC",
  },
];
